<template>
<span class="h-full w-full">
  <el-input v-if="modifiable" type="number" ref="numberEditor"  v-model="editing.value"
  :min="minValue" :max="max" @blur="focusOut()" @keyup.enter.native="focusOut()" controls-position="right"></el-input>
  <slot v-else-if="useSlot" name="data"> </slot>
  <span v-else > {{getValueAfterCheckEmpty(displayValue)}} </span>
</span>
</template>

<script>
import isNil from 'lodash/isNil';
import Editingf from '@/mixins/editingForm';
import {
  getValueAfterCheckEmpty
} from '@/utils/string';
export default {
  name: 'w-number-form',
  // useSlot = 수정모드 아닐 시 slot 사용 여부
  // - true : 개발 시 원하는 값(형식) 셋팅 가능
  // - false : target[property] 값 보여줌 (default값으로 useSlot 설정안해도 됨)
  props: ['modifiable', 'target', 'property', 'min', 'max', 'useSlot'],
  mixins: [Editingf],
  computed: {
    displayValue() {
      if (!isNil(this.target)) {
        return this.target[this.property];
      }
    },
    minValue() {
      if (this.min) {
        return 0;
      } else {
        return this.min;
      }
    }
  },
  watch: {
    target: {
      handler: function(val, oldVal) {
        // // 수정모드 도중 외부 작용에 의해 기존 target 데이터가 변경 되었다면 editing값도 맞추어 변경
        // if (this.modifiable && this.editing.isEditing && (this.target[this.property] !== this.editing.value)) {
        //   console.log('외부 작용 : ', this.editing.isEditing, this.target[this.property], this.editing.value);
        //   this.editing.value = this.target[this.property];
        //   this.updateEdit(this.editing.value);
        // }
      },
      deep: true
    },
    modifiable: {
      immediate: true,
      deep: true,
      handler: function(val, oldVal) {
        if (val) {
          this.startEdit(this.target, this.property);
        } else if (!isNil(oldVal)) {
          // 수정 진행 -> 종료 일경우에만
          this.endEdit(this.editing.value);
        }
      }
    },
  },
  methods: {
    getValueAfterCheckEmpty,
    focusOut() {
      this.updateEdit(_.toInteger(this.editing.value));
    },
  },
  data() {
    return {};
  }
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/formeditor/NumberFormEditor.vue